import { IAuthResponse } from '@models/response/IAuthResponse';
import { AxiosInstance, AxiosResponse } from 'axios';
import { ConfigService } from '@/configuration/services/configService';
import $api from '@/http';
export const samlForceAuthn: boolean = ConfigService.get().application.authentication.saml.forceAuthn;

export class SamlAuthService {
    static getSender(): AxiosInstance {
        return $api;
    }

    /** `forceAuthn` — IdP спрашивает пароль заново (добавление учётки); иначе — из конфигурации стенда. */
    static async getSignInRedirectLocationAsync(rememberMe: boolean, forceAuthn = false): Promise<string> {
        let response = await this.getSender().post<void>('/Account/saml/signin-request', null, {
            params: {
                forceAuthn: forceAuthn || samlForceAuthn,
                rememberMe: rememberMe,
            },
        });
        if (response.status === 200) {
            let location = response.headers['location'];
            if (location) {
                return Promise.resolve(location);
            }
        }
        return Promise.reject();
    }

    static async getSignOutRedirectLocationAsync(): Promise<string> {
        let response = await this.getSender().post<void>('/Account/saml/signout-request');
        if (response.status === 200) {
            let location = response.headers['location'];
            if (location) {
                return Promise.resolve(location);
            }
        }
        return Promise.reject();
    }

    static async loginAsync(): Promise<AxiosResponse<IAuthResponse>> {
        return this.getSender().post<IAuthResponse>('/Account/saml/signin');
    }
}
